import { z } from 'zod';

export const teamSchema = z.object({
  name: z.string().trim().min(1, { message: 'Team name is required' }),
});
